module.exports = "./static/shtk-icon.e72c4426.png";